import { DefaultTheme } from 'styled-components';
import { withAlpha } from './helpers';

import { Colors } from '@user-portal/wikr-components';

export const color =
  (colorKey: Colors, alpha?: number) =>
  ({ theme }: { theme: DefaultTheme }) => {
    const themeColor = theme[colorKey];

    return alpha && themeColor ? withAlpha(themeColor, alpha) : (themeColor ?? '');
  };
